import feathersClient, { makeServicePlugin, BaseModel } from '@/api-client'

class Shop extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Shop'

  static instanceDefaults (data, { store, models }) {
    return {
      status: 'ACTIVE',
      usesInvoicing: true,
      usesOrdering: false,
      exportCCC1: false
    }
  }
}
const servicePath = 'shops'
const servicePlugin = makeServicePlugin({
  Model: Shop,
  // IMPORTANT
  whitelist: [
    '$eager',
    '$iRegexp',
    '$regex',
    '$options',
    '$mergeEager',
    '$or',
    '$and',
    '$modifiers',
    '$select',
    '$joinRelation',
    '$relation'
  ],
  allowEager: 'region,regionalTag',
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
